import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { contentStyles, titleStyles, wrapperStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useTranslation } from "react-i18next";

const CoffeeCallRejected = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();
  return (
    <Box sx={wrapperStyles(darkMode)}>
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <Cancel sx={{ color: "#dc2626", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {notification?.title}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "var(--neutral-300)" : "var(--neutral-500)",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CoffeeCallRejected;
